import React from "react";
import { Link, useLocation } from "react-router-dom";

interface SidebarMenuProps {
  name: string;
  icon: string;
  path: string;
  isNavigationHeader?: boolean;
  children?: SidebarMenuProps[];
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({ name, icon, path }) => {
  const location = useLocation();

  return (
    <li>
      <Link to={`${path}${location.search}`}>
        <i className={icon}></i> <span>{name}</span>
      </Link>
    </li>
  );
};

export default SidebarMenu;
